import { Directive, forwardRef, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator } from '@angular/forms';

@Directive({
    selector: '[validateAlphaNumericAndSafeSymbols][formControlName],[validateAlphaNumericAndSafeSymbols][formControl],[validateAlphaNumericAndSafeSymbols][ngModel]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => AlphaNumericAndSafeSymbolsValidatorDirective),
            multi: true,
        },
    ],
})
export class AlphaNumericAndSafeSymbolsValidatorDirective implements Validator
{
    @Input() addressLine: string;

    public validate(control: AbstractControl): { [key: string]: any } {
        const pattern = /^[A-Za-z0-9.'#@%&/\- ]*$/;
        const valid = pattern.test(control.value);
        return valid ? null : {'invalidAlphaNumericAndSafeSymbols': true};
    }
}
